import { gql } from '@apollo/client';

export const GET_FILTERED_DOCUMENT_TYPES = gql`
  query GetFilteredDocumentTypes($input: FilteredDocumentTypesInput) {
    documentTypes: getFilteredDocumentTypes(input: $input) {
      id
      required
    }
  }
`;
